import { apiThunk } from '../../Utils/apiThunk';
import type { AppDispatch } from '../../Store/types';

export const packageResourceUrl = (packageId: string, resource: string, versionId: string | undefined, id?: string): string => {
    const path = id === undefined ? `/api/packages/${packageId}/${resource}` : `/api/packages/${packageId}/${resource}/${id}`;

    return versionId === undefined || versionId.length === 0 ? path : `${path}?versionId=${versionId}`;
};

// resolves true on success and false on failure (the error toast has already been shown), so a DELETE's empty body
// is not mistaken for a failure and callers do not need a separate success callback
export const mutatePackageResource = (url: string, init: RequestInit) => (dispatch: AppDispatch) =>
    dispatch(apiThunk<unknown>(url, { init, rethrow: true }))
        .then(() => true)
        .catch(() => false);
